import { jsxs as c, Fragment as k, jsx as o } from "react/jsx-runtime";
import { useState as b, useCallback as m } from "react";
import s from "../Button/index.js";
import O from "../ListView/index.js";
import w from "../Modal/index.js";
import M from "../../hooks/useTranslation.js";
const x = "common", y = {
  confirmation: "Confirmation",
  confirmMessage: "Are you sure you want to continue?",
  buttonCancel: "Cancel",
  buttonOk: "Ok"
}, j = {
  namespace: x,
  strings: y
};
function F(l) {
  const n = M(j), {
    confirmHeading: f = n.confirmation,
    confirmMessage: u = n.confirmMessage,
    name: r,
    onConfirm: a,
    onClick: t,
    ...C
  } = l, [d, i] = b(!1), p = m(
    (e) => {
      i(!1), a(e);
    },
    [a]
  ), g = m(
    (e, h) => {
      t && t(e, h), i(!0);
    },
    [t]
  );
  return /* @__PURE__ */ c(k, { children: [
    /* @__PURE__ */ o(
      s,
      {
        ...C,
        name: r,
        onClick: g
      }
    ),
    d && /* @__PURE__ */ o(
      w,
      {
        heading: f,
        closeOnEscape: !1,
        size: "sm",
        footerActions: /* @__PURE__ */ c(O, { spacing: "sm", children: [
          /* @__PURE__ */ o(
            s,
            {
              name: !1,
              onClick: i,
              children: n.buttonCancel
            }
          ),
          /* @__PURE__ */ o(
            s,
            {
              name: r,
              styleVariant: "filled",
              onClick: p,
              children: n.buttonOk
            }
          )
        ] }),
        children: u
      }
    )
  ] });
}
export {
  F as default
};
